import React, { useState } from 'react';
import { BillingToggle } from '../components/pricing/BillingToggle';
import { PlanCards } from '../components/pricing/PlanCards';
import { TrustStrip } from '../components/pricing/TrustStrip';
import { ComparisonTable } from '../components/pricing/ComparisonTable';
import { PaymentFees } from '../components/pricing/PaymentFees';
import { AddOns } from '../components/pricing/AddOns';
import { FinanceCallout } from '../components/pricing/FinanceCallout';
import { PricingCta } from '../components/pricing/PricingCta';
import { ProductTestimonial } from '../components/product/ProductTestimonial';
import { ProductFaq } from '../components/product/ProductFaq';
import { addOns, comparisonGroups, plans, pricingFaq, pricingTestimonial, trustItems } from '../data/pricing';
import type { Billing } from '../types/pricing';
export function Pricing() {
  const [billing, setBilling] = useState<Billing>('monthly');
  return <main data-id="element-2110" data-mp="1ajuzjldldyr5">
      <section className="hero-surface w-full" aria-labelledby="pricing-heading" data-id="element-2111" data-mp="1aj372jfakh53">
        <div className="mx-auto max-w-shell px-6 pb-16 pt-14 lg:pt-20" data-id="element-2112" data-mp="1el5cnd6lnjlq">
          <div className="text-center" data-id="element-2113" data-mp="1jlkpm3myyp36">
            <h1 id="pricing-heading" className="display mx-auto max-w-[760px] text-[38px] font-semibold text-ink sm:text-[50px] lg:text-[56px]" data-id="element-2114" data-mp="1jmm8gua88fvg">
              Simple pricing that grows with your business
            </h1>
            <p className="mx-auto mt-5 max-w-[540px] text-[18px] leading-[1.5] text-ink-muted" data-id="element-2115" data-mp="1xc683r8igx0j">
              Every plan includes RRA EBM receipts and local support. No setup fees, no hidden charges.
            </p>
            <div className="mt-9 flex justify-center" data-id="element-2116" data-mp="1nllao74kpyj7">
              <BillingToggle value={billing} onChange={setBilling} data-id="element-2117" data-mp="1slpv288lrdep" />
            </div>
          </div>

          <div className="mt-12" data-id="element-2118" data-mp="2gbad8owxm6mx">
            <PlanCards plans={plans} billing={billing} data-id="element-2119" data-mp="2ga92ymnqpo69" />
            <TrustStrip items={trustItems} data-id="element-2120" data-mp="2l20je4d6mdio" />
          </div>
        </div>
      </section>

      <ComparisonTable plans={plans} groups={comparisonGroups} billing={billing} data-id="element-2121" data-mp="2l3v87trkqps1" />
      <PaymentFees data-id="element-2122" data-mp="2ux7ra8raw2gr" />
      <AddOns items={addOns} data-id="element-2123" data-mp="2uvmvkft92dhb" />
      <FinanceCallout data-id="element-2124" data-mp="2pyo5c8cpiqoe" />
      <ProductTestimonial testimonial={pricingTestimonial} data-id="element-2125" data-mp="2q07m0029z3qp" />
      <ProductFaq heading="Frequently asked questions" items={pricingFaq} data-id="element-2126" data-mp="2lx2o6at53q8e" />
      <PricingCta data-id="element-2127" data-mp="2lz5n5kc9stp9" />
    </main>;
}